import {
    ChangeDetectionStrategy,
    Component,
    CUSTOM_ELEMENTS_SCHEMA,
    forwardRef,
    input,
    InputSignal,
    signal,
    WritableSignal
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'sh-toggle-accessor',
    templateUrl: './sh-toggle-accessor.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ShToggleAccessorComponent),
            multi: true
        }
    ],
    host: {
        '(click)': 'toggle()'
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ShToggleAccessorComponent implements ControlValueAccessor {
    public label: InputSignal<string> = input<string>('');
    public readonly: InputSignal<boolean> = input<boolean>(false);

    protected active: WritableSignal<boolean> = signal(false);
    protected disabled: WritableSignal<boolean> = signal(false);

    private onChange: (v: boolean) => void = () => void 0;
    private onTouched: () => void = () => void 0;

    public writeValue(obj: unknown): void {
        this.active.set(!!obj);
    }

    public registerOnChange(fn: (v: boolean) => void): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    public setDisabledState(isDisabled: boolean): void {
        this.disabled.set(isDisabled);
    }

    public toggle(): void {
        if (this.disabled() || this.readonly()) return;
        this.active.set(!this.active());
        this.onChange(this.active());
        this.onTouched();
    }
}
